import { Button, Container, Stack, Typography, Card, Box, capitalize, Modal, MenuItem, Select } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../store/hooks';
import { QrReader } from 'react-qr-reader';
import { useUpdateActualTimeMutation, useUpdateBookingDetailMutation } from '../store/api/bookingsApi';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom';
import '../components/Style.css';
import { capitalName, extraBookingHour, roundNumber } from '../sections/@dashboard/parkingspaces/utility';
import {
  useCalculateBillingRateMutation,
  useCalculateExtraBillingMutation,
} from '../store/api/calculateBillingRateApi';
import { format } from 'date-fns';
import Loading from '../components/Loading';
import { setCalculateBilling } from '../store/state/calculateBillingSlice';
import toast from 'react-hot-toast';
import { capitalCase } from 'change-case';
import { useCheckStatusMutation, useStartPaymentMutation } from '../store/api/posApi';
import { Formik } from 'formik';
import { useGetAllDeviceDataMutation } from '../store/api/posDeviceApi';
import ClearIcon from '@mui/icons-material/Clear';


export default function QRCodeScanner() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<string | null>(null);
  const [flag, setFlag] = useState<string | null>(null);
  const [showScanner, setShowScanner] = useState<boolean>(true);
  const [showData, setShowData] = useState<boolean>(false);
  const [responseData, setResponseData] = useState<any>();
  const [updateActualTime, updateActualTimeResponse] = useUpdateActualTimeMutation();
  const authData:any = JSON.parse(localStorage.getItem('login') || '{}');
  const [calculateBillingRate, billingRateResponse] = useCalculateExtraBillingMutation();
  const [billigData, setBillingData] = useState() as any;
  const [startPayment, startPaymentResponse] = useStartPaymentMutation();
  const [checkStatus, checkStatusResponse] = useCheckStatusMutation();
  const [updateBookingDetail, updateBookingDetailResponse] = useUpdateBookingDetailMutation();
  const [subBookingId, setSubBookingId] = useState() as any;
  const [traxnId, setTraxnId] = useState() as any;
  const [openModal, setOpenModal] = useState(false);
  const [getAllDeviceData, getAllDeviceDataResponse] = useGetAllDeviceDataMutation();
  const [posDeviceData, setPosDeviceData] = useState([]) as any;
  const [responseDetail,setResponseDetail] = useState([])as any ;
  





  const [initialValues, setInitialValues] = useState({
    posDevice:''
   });

   const validate = (values: any) => {
    console.log(values)
    const errors: any = {};

    if (!values.posDevice) errors['posDevice'] = 'This field is required';
    return errors;
};

const styleActiveModel = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '10px',
  p: '40px',
  px: '30px',
};


const handleOpenModal = (id: any) => {
  console.log(id, id);
  setOpenModal(true);
  getAllDeviceData({
    token: authData.token,
    payload: {
      offset: 100,
      page: 0,
      parkingLocationId: id,
      status: true,
    },
  });

};
const handleCloseModal = () => setOpenModal(false);


useEffect(() => {
  if (getAllDeviceDataResponse.isSuccess) {
    setPosDeviceData(getAllDeviceDataResponse.data.data);
  }
  if (getAllDeviceDataResponse.isError) {
    let errorData: any = getAllDeviceDataResponse.error;
    let msg: any = errorData?.data?.serviceErrors[0]?.msg;
    toast.error('Something went wrong ' + msg || '');
  }
}, [getAllDeviceDataResponse.isSuccess, getAllDeviceDataResponse.isError]);


  useEffect(() => {
    if (data && authData) {
      // let data = "100|AS-1|1654835419832|checkout";
      setFlag(data.split('|')[5]);
      updateActualAsync(data, authData.token);
    }
  }, [data]);

  const updateActualAsync = async (data: string, token: string) => {
    await updateActualTime({
      token: token,
      payload: {
        bookingQr: data,
        isGuest: false,
        isVirtual: false,
        currDate: new Date(),
        flag: data.split('|')[5],
        subBookingId: data.split('|')[6],
      },
    });
    setSubBookingId(data.split('|')[6]);
  };

  useEffect(() => {
    if (updateActualTimeResponse.isSuccess) {
      setResponseData(updateActualTimeResponse.data);
      setShowScanner(false);
      setShowData(true);
      if (flag === 'checkout') {
        checkOutComplete(updateActualTimeResponse.data);
      }
    }
  }, [updateActualTimeResponse.isSuccess]);

  const bookingTime =
    responseData &&
    extraBookingHour(responseData.actualCheckinTime, responseData.actualCheckoutTime, responseData.bookingStatus);
  const extraBookingTime = (bookingTime - 7200000) / 1000 / 60 / 60;

  const checkOutComplete = (value: any) => {
    calculateBillingRate({
      token: authData.token,
      payload: {
        bookingId: value?.id,
        parkingSpaceLocationId: value?.parkingLocationId,
        subBookingId: value?.subBookingDetailList[0]?.id,
      },
    });
  };

  useEffect(() => {
    if (billingRateResponse.isSuccess) {
      dispatch(setCalculateBilling(billingRateResponse.data));
      setBillingData(billingRateResponse.data);
    }
  }, [billingRateResponse.isSuccess]);

  //pos code start
  const handleStartPayment = (values: any) => {
    handleCloseModal();
    startPayment({
      token: authData.token,
      payload: {
        amount: responseDetail.totalAmount,
        appKey: '252488f7-42d5-4830-bffc-a75e54214807',
        customerEmail: responseDetail.customerDetailResponseDTO.email,
        customerMobileNumber: responseDetail.customerDetailResponseDTO.phoneNo,
        customerName: responseDetail.customerDetailResponseDTO.name,
        externalRefNumber: responseDetail.bookingCode,
        mode: 'ALL',
        pushTo: { deviceId:`${values.posDevice}|ezetap_android`},
        username: '3939000201',
      },
    });
  };

  const [messageCode, setMessageCode] = useState();

  function handleCheckStatus() {
    checkStatus({
      token: authData.token,
      requestId: startPaymentResponse?.data?.p2pRequestId,
    });
  }

  const [id, setId] = useState() as any;

  useEffect(() => {
    if (startPaymentResponse?.data?.success === true) {
      const intervalID = setInterval(handleCheckStatus, 5000);
      setId(intervalID);
    }
    if (startPaymentResponse?.data?.success === false) {
      const errorData: any = startPaymentResponse?.data?.errorMessage;
      toast.error('Something went wrong. ' + errorData);
    }
    // return () => clearInterval(id);
  }, [startPaymentResponse?.data]);

  useEffect(() => {
    if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_TXN_DONE'
    ) {
      setTraxnId(checkStatusResponse?.data?.txnId);
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.success('Transaction successfully done on POS Device.');
      }
      handlePayment(responseData, 'pos');
      clearInterval(id);
      setId(0);
    } else if (
      checkStatusResponse?.data?.errorMessage ==
        'You have already made a similar payment for the same Ref# null and amount {1}. Please check the status of the payment(s) made before you proceed.' &&
      checkStatusResponse?.data?.status === 'FAILED' &&
      checkStatusResponse?.data?.success === false
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.success(
          'You have already made a similar payment for the same request and amount. Please check the status of the payment(s) made before you proceed.'
        );
        }
      clearInterval(id);
      setId(0);
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_STATUS_QUEUED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) toast.success('Request queued please wait.');
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_RECEIVED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode)
        toast.success('Notification has been received on POS Device. Please wait.');
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_CANCELED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.error('Transaction has been canceled on POS Device.');
      }
      clearInterval(id);
      setId(0);
    } else if (checkStatusResponse?.data?.success === false) {
      setMessageCode(checkStatusResponse?.data?.errorData);
      const errorData: any = checkStatusResponse?.data?.errorMessage;
      if (messageCode !== checkStatusResponse?.data?.errorData) {
        toast.error('Something went wrong ' + errorData);
      }
      clearInterval(id);
      setId(0);
    }
    // return () => clearInterval(id);
  }, [checkStatusResponse?.data, messageCode]);

  const handlePayment = (responseData: any, paidBy: any) => {
    updateBookingDetail({
      token: authData.token,
      payload: {
        bookingAmount: responseData?.bookingAmount,
        bookingCode: responseData?.bookingCode,
        bookingDate: responseData?.bookingDate,
        bookingStatus: responseData?.bookingStatus,
        cardAmount: responseData?.cardAmount,
        cartId: responseData?.cartId,
        checkinTime: responseData?.checkinTime,
        checkoutTime: responseData?.checkoutTime,
        convenienceFee: responseData?.convenienceFee,
        countyTax: responseData?.countyTax,
        customerId: responseData?.customerId,
        // customerVehicleDetailResDTO: {
        //   customerId: responseData?.customerVehicleDetailResDTO?.customerId,
        //   id: responseData?.customerVehicleDetailResDTO?.id,
        //   isCommercial: responseData?.customerVehicleDetailResDTO?.isCommercial,
        //   isPrimary: responseData?.customerVehicleDetailResDTO?.isPrimary,
        //   makerName: responseData?.customerVehicleDetailResDTO?.makerName,
        //   modelNumber: responseData?.customerVehicleDetailResDTO?.modelNumber,
        //   status: responseData?.customerVehicleDetailResDTO?.status,
        //   vehicleCategory: responseData?.customerVehicleDetailResDTO?.vehicleCategory,
        //   vehicleNumber: responseData?.customerVehicleDetailResDTO?.vehicleNumber,
        // },
        disputeResolutionDate: responseData?.disputeResolutionDate,
        email: responseData?.customerDetailResponseDTO?.email,
        // extraAmount: responseData?.extraAmount,
        // extraAmtTransId: responseData?.extraAmtTransId,
        fixedFee: responseData?.fixedFee,
        id: responseData?.id,
        // invoiceDate: responseData?.invoiceDate,
        invoiceType: paidBy === 'pos' ? 'POS' : 'CASH',
        isDisputed: responseData?.isDisputed,
        isGuest: responseData?.isGuest,
        isParked: responseData?.isParked,
        isVendorPaid: responseData?.isVendorPaid,
        // offerDetailId: responseData?.offerDetailId,
        paidBy: paidBy,
        parkingCategoryId: responseData?.parkingCategoryId,
        parkingLocationId: responseData?.parkingLocationId,
        parkingSlotId: responseData?.parkingSlotId,
        // paymentMethodId: responseData?.paymentMethodId,
        paymentStatus: 'Completed',
        phoneNo: responseData?.customerDetailResponseDTO?.phoneNo,
        // qrImage: responseData?.qrImage,
        rewardGained: responseData?.rewardGained,
        rewardUsed: responseData?.rewardUsed,
        salesTax: responseData?.salesTax,
        serviceProviderId: responseData?.serviceProviderId,
        stateTax: responseData?.stateTax,
        status: responseData?.status,
        subBookingId: subBookingId,
        taxAmount: responseData?.taxAmount,
        totalAmount: responseData?.totalAmount,
        transactionRefId: paidBy == 'pos' ? traxnId : responseData?.transactionRefId,
        uniqueBookingId: responseData?.uniqueBookingId,
        userTimezone: responseData?.userTimezone,
        vehicleNumber: responseData?.vehicleNumber,
      },
    });
  };

  useEffect(() => {
    if (updateBookingDetailResponse.isSuccess) {
      setTimeout(() => {
        toast.success('Checked in successfully !');
      }, 3000);
    } else if (updateBookingDetailResponse.isError) {
      const errorData: any = updateBookingDetailResponse.error;
      const msg: any = errorData.data.serviceErrors[0].msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [updateBookingDetailResponse.isSuccess, updateBookingDetailResponse.isError]);

  //pos code end

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          Scan QR Code
        </Typography>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            navigate('/dashboard/bookings');
          }}
          sx={{ marginBottom: '10px' }}
          size="medium"
        >
          <ArrowBackIcon />
        </Button>
      </Stack>
      {showScanner && (
        <Box style={{ display: 'flex', justifyItems: 'center' }}>
          <QrReader
            scanDelay={300}
            key="environment"
            onResult={(result, error) => {
              if (!!result) {
                setData(result.toString());
                // console.log(result.toString(), 'result.toString()');
              }
              if (!!error) {
                console.info(error);
              }
            }}
            constraints={{ facingMode: 'environment' }}
            containerStyle={{ width: '500px', height: '500px', border: '1px solid', alignItem: 'center' }}
            className="qrcodeStyle qrCodeContainerStyle"
          />
        </Box>
      )}
      {showData && responseData && (
        <Card style={{ padding: '40px' }}>
          <Box className="qrcode" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            {(flag == 'checkin' || flag == 'checkincheckout' || flag == 'checkout') && (
              <Box>
                <Typography variant="h4">
                  {(responseData?.paidBy !== 'pos' || responseData?.paidBy !== 'CASH') &&
                  updateBookingDetailResponse?.data?.paymentStatus === 'Completed' &&
                  responseData?.isCheckOut == false
                    ? 'Checked In Successfully !!'
                    :responseData?.isCheckIn == true && responseData?.paymentStatus=='Completed' ? 
                    'Checked In Successfully !!'
                    : responseData?.paidBy === 'pos' &&
                      responseData?.paymentStatus === 'Pending' &&
                      responseData?.isCheckOut == false
                    ? 'Payment Pending !!'
                    : responseData?.paidBy === 'CASH' &&
                      responseData?.paymentStatus === 'Pending' &&
                      responseData?.isCheckOut == false
                    ? 'Payment Pending !!'
                    : responseData?.isCheckOut == true && responseData?.paymentStatus === 'Completed'
                    ? 'Checked Out Successfully !!'
                    : ''}
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            className="qrcode"
            style={{ display: 'flex', flexDirection: 'row', marginTop: '20px', justifyContent: 'space-between' }}
          >
            <Box style={{ display: 'flex', flexDirection: 'column' }}>
              <Box style={{ marginTop: '5px' }}>
                <Typography variant="h6">Booking Code: {responseData.bookingCode}</Typography>
              </Box>
              <Box style={{ marginTop: '5px' }}>
                <Typography variant="h6">
                  Customer Name: {responseData.customerName ? responseData.customerName : '--'}
                </Typography>
              </Box>
              <Box style={{ marginTop: '5px' }}>
                <Typography variant="h6">
                  Checkin Time:{' '}
                  {responseData.actualCheckinTime
                    ? moment(responseData.actualCheckinTime.toString()).format('MM/DD/yyyy, hh:mm A')
                    : ''}
                </Typography>
              </Box>
              {/* pos code start */}
              {responseData.isCheckOut !== true
                ? responseData.actualCheckoutTime === null &&
                  (responseData?.paidBy == 'CASH' || responseData?.paidBy == 'pos')  && responseData?.paymentStatus !=='Completed' && (
                    <Box style={{ marginTop: '5px' }}>
                      <Typography variant="h6" style={{ alignItems: 'start' }}>
                        Payment To Be Done By: {responseData.paidBy === 'pos' ? 'POS' : responseData.paidBy}
                      </Typography>
                    </Box>
                  )
                : ''}

              {responseData.actualCheckoutTime !== null && (
                <Box style={{ marginTop: '5px' }}>
                  <Typography variant="h6">
                    Extra Booking Hour : {billigData?.extraHours !== null ? billigData?.extraHours : 0} hrs
                  </Typography>
                </Box>
              )}
            </Box>

            <Box style={{ display: 'flex', flexDirection: 'column' }}>
              <Box style={{ marginTop: '5px' }}>
                <Typography variant="h6">
                  Booking Date:{' '}
                  {responseData.bookingDate
                    ? moment(responseData.bookingDate.toString()).format('MM/DD/yyyy, hh:mm A')
                    : ''}
                </Typography>
              </Box>
              {responseData.paidAmount !== null && (
                <Box style={{ marginTop: '5px' }}>
                  <Typography variant="h6">Amount Paid: ₹ {roundNumber(responseData.paidAmount)}</Typography>
                </Box>
              )}
              {responseData.actualCheckoutTime !== null && (
                <Box style={{ marginTop: '5px' }}>
                  <Typography variant="h6">
                    Checkout Time :{' '}
                    {responseData.actualCheckoutTime
                      ? moment(responseData.actualCheckoutTime.toString()).format('MM/DD/yyyy, hh:mm A')
                      : 'N/A'}
                  </Typography>
                </Box>
              )}
              {responseData.actualCheckoutTime !== null && (
                <Box style={{ marginTop: '5px' }}>
                  <Typography variant="h6" style={{ alignItems: 'start' }}>
                    Pending Amount: ₹{roundNumber(billigData?.pendingAmount !== null ? billigData?.pendingAmount : 0)}
                  </Typography>
                </Box>
              )}
              {/* pos code start */}
              {responseData.isCheckOut !== true
                ? responseData.actualCheckoutTime === null &&
                  (responseData.paidBy === 'CASH' || responseData.paidBy === 'pos') && responseData?.paymentStatus !=='Completed' && (
                    <Box style={{ marginTop: '5px' }}>
                      <Typography variant="h6" style={{ alignItems: 'start' }}>
                        Amount To Be Collected From Customer: ₹ {roundNumber(responseData.totalAmount)}
                      </Typography>
                    </Box>
                  )
                : ''}
              {/* {responseData.isCheckOut !== true || responseData?.paymentStatus !=='Completed'
                ? responseData.actualCheckoutTime === null &&
                  responseData.paidBy === 'pos' && (
                    <Box style={{ marginTop: '5px' }}>
                      <Button
                        style={{
                          color: 'white',
                          backgroundColor:
                            responseData.paymentStatus === 'Completed' ||
                            updateBookingDetailResponse?.data?.paymentStatus === 'Completed'
                              ? '#cac8c8'
                              : '#E23744',
                          alignItems: 'start',
                        }}
                        variant="contained"
                        onClick={() => {
                          // handleStartPayment(responseData);
                          setResponseDetail(responseData)
                          handleOpenModal(responseData?.parkingSpaceLocationRespDTO?.id)
                        }}
                        disabled={
                          updateBookingDetailResponse?.data?.paymentStatus === 'Completed' ||
                          responseData.paymentStatus === 'Completed'
                        }
                      >
                        Pay By POS{' '}
                      </Button>
                    </Box>
                  )
                : ''} */}
              {responseData.isCheckOut !== true
                ? responseData.actualCheckoutTime === null &&
                  responseData.paidBy === 'pos' && (
                    <Box style={{ marginTop: '5px' }}>
                      <Button
                        style={{
                          color: 'white',
                          backgroundColor:
                            responseData.paymentStatus === 'Completed' ||
                            updateBookingDetailResponse?.data?.paymentStatus === 'Completed'
                              ? '#cac8c8'
                              : '#E23744',
                          alignItems: 'start',
                        }}
                        variant="contained"
                        onClick={() => {
                          handlePayment(responseData, 'CASH');
                        }}
                        disabled={
                          updateBookingDetailResponse?.data?.paymentStatus === 'Completed' ||
                          responseData.paymentStatus === 'Completed'
                        }
                      >
                        Pay By Cash{' '}
                      </Button>
                    </Box>
                  )
                : ''}
              {responseData.isCheckOut !== true
                ? responseData.actualCheckoutTime === null &&
                  responseData.paidBy === 'CASH' && (
                    <Box style={{ marginTop: '5px' }}>
                      <Button
                        style={{
                          color: 'white',
                          backgroundColor:
                            updateBookingDetailResponse?.data?.paymentStatus === 'Completed' ||
                            responseData.paymentStatus === 'Completed'
                              ? '#cac8c8'
                              : '#E23744',
                          alignItems: 'start',
                        }}
                        variant="contained"
                        onClick={() => {
                          handlePayment(responseData, 'CASH');
                        }}
                        disabled={
                          updateBookingDetailResponse?.data?.paymentStatus === 'Completed' ||
                          responseData.paymentStatus === 'Completed'
                        }
                      >
                        Payment Recieved?{' '}
                      </Button>
                    </Box>
                  )
                : ''}
              {/* pos code end */}
            </Box>
          </Box>
          <Modal
        open={openModal}
        onClose={handleOpenModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%' }}
      >
        <Box sx={styleActiveModel} style={{ overflowY: 'auto', height: '40%', width: '30%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Pos Machine
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleCloseModal();
              }}
              size="medium"
            >
              <ClearIcon/>
            </Button>
          </Stack>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleStartPayment}
            validate={validate}
          >
            {({ handleBlur, handleChange, handleSubmit, setFieldValue, values, touched, errors }) => (
              <Box style={{ width: '100%' }}>
              
        
                  <Box style={{ width: '100%' }}>
                    <Typography variant="h5" marginTop={2} gutterBottom component="div">
                      Pos Device
                    </Typography>
                    <Select
                      id="posDevice"
                      name="posDevice"
                      style={{ width: '100%' }}
                      value={values.posDevice}
                      onChange={(event: any) => {
                        setFieldValue('posDevice', event.target.value);
                      }}
                      onBlur={handleBlur}
                      error={Boolean(touched.posDevice && errors.posDevice)}
                      displayEmpty
                    >
                      <MenuItem disabled value="">
                        Select Pos Device
                      </MenuItem>
                      {posDeviceData && posDeviceData.map((posDeviceData: any) => (
                          <MenuItem key={posDeviceData.deviceId} value={posDeviceData.deviceId}>
                            {posDeviceData.name}
                          </MenuItem>
                        ))}
                    </Select>
                    {errors.posDevice && <div style={{ color: 'red' }}>{errors.posDevice}</div>}
                  </Box>
                <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                  <Button
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                    variant="contained"
                    size="large"
                    component="span"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            )}
          </Formik>


        </Box>
      </Modal>
        </Card>
      )}
      {billingRateResponse.isLoading || updateActualTimeResponse.isLoading ? <Loading /> : null}
    </Container>
  );
}
